import React, { useEffect } from 'react';

import { useHistory } from 'react-router';
import { getPath } from 'utils/router';
import { connect, useDispatch } from 'react-redux';

import {
    API_COMPTE_CREER_EMPLOYE_METIER_ASSO,
    CONTEXT_CREER_EMPLOYE_METIER_ASSO,
} from 'constants/apiUrls.constants';
import PropTypes from 'prop-types';
import usagerClientReducer from 'store/usagerReducer';
import { Button, ButtonGroup, ButtonLink, Col, Row, SegmentLoader } from '@si-armes/dsfr-react';
import { Link } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';

import EmployeForm from './EmployeForm';
import RoutesMonCompte from '../routes';
import RoutesListeEmployes from '../liste-employes/routes';

const AjouterEmploye = ({ isLoadingCreerEmploye, dataCreerEmploye }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const hookForm = useForm({
        mode: 'onChange',
    });

    const {
        formState: { isValid },
        handleSubmit,
    } = hookForm;

    const onSubmit = async (data) => {
        dispatch(
            postAPI(
                usagerClientReducer,
                API_COMPTE_CREER_EMPLOYE_METIER_ASSO,
                data,
                CONTEXT_CREER_EMPLOYE_METIER_ASSO,
            ),
        );
    };

    useEffect(() => {
        if (dataCreerEmploye) {
            const handleRedirect = async () => {
                await dispatch(reinitialiseAPI(CONTEXT_CREER_EMPLOYE_METIER_ASSO));

                history.push(getPath(RoutesListeEmployes));
            };

            handleRedirect();
        }
    }, [dataCreerEmploye]);

    return (
        <SegmentLoader isLoading={isLoadingCreerEmploye}>
            <h1>Ajouter un nouvel employé</h1>

            <ButtonLink
                as={Link}
                name="ajouterEmploye"
                to={getPath(RoutesMonCompte.subroutes.listeEmployes)}
                variant="secondary"
                icon="fr-fi-arrow-left-line"
                iconPosition="left"
            >
                Liste des employés
            </ButtonLink>

            <div className="employeManagement-marginTop">
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <EmployeForm />
                        <Row className="margin-top-lg">
                            <Col>
                                <ButtonGroup inline align="right">
                                    <Link
                                        to={getPath(RoutesListeEmployes)}
                                        style={{ backgroundImage: 'none' }}
                                    >
                                        <Button
                                            name="etapePrecedente"
                                            variant="secondary"
                                            type="button"
                                        >
                                            Annuler
                                        </Button>
                                    </Link>
                                    <Button
                                        name="etapeSuivante"
                                        variant="primary"
                                        type="submit"
                                        disabled={!isValid}
                                    >
                                        Valider
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </div>
        </SegmentLoader>
    );
};

AjouterEmploye.propTypes = {
    isLoadingCreerEmploye: PropTypes.bool,
    errorCreerEmploye: PropTypes.bool,
    dataCreerEmploye: PropTypes.object,
};

export default connect(
    (state) => {
        const {
            isLoading: isLoadingCreerEmploye,
            data: dataCreerEmploye,
            error: errorCreerEmploye,
        } = state.gestionEmployes.creerEmploye || {};

        return {
            isLoadingCreerEmploye,
            errorCreerEmploye,
            dataCreerEmploye,
        };
    },
    {
        postApi: postAPI,
    },
)(AjouterEmploye);
